import axiosClient from './axiosClient';

async function requestCancellationService(orderNo: string, lastName: string, agencyId: string) {
  const bodyRequest = { orderNo, lastName, agencyId };

  try {
    const response = await axiosClient.post('/cancellation/requestCancellation', bodyRequest);
    return response.data;
  } catch (error: any) {
    console.log(error);
    return null;
  }
}

export default requestCancellationService;
